import { useState, useEffect } from "react";
import { Smartphone, Share, X } from "lucide-react";
import { Button } from "../components/ui/button";

const DISMISS_KEY = "savi_install_dismissed";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallAppCard = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) || isStandalone()) return;

    if (isIOS()) {
      setShow(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShow(false);
  };

  return (
    <div className="bg-[#1A1A1A] rounded-2xl p-4 text-white mt-4 relative" data-testid="install-app-card">
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 text-white/50 hover:text-white"
        data-testid="install-app-dismiss"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-6">
        <div className="w-10 h-10 rounded-xl bg-[#C85A38] flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm">Get the Savi app</p>
          {isIOS() ? (
            <p className="text-white/70 text-xs mt-1 flex items-center gap-1 flex-wrap">
              Tap <Share className="w-3.5 h-3.5 inline" /> Share, then "Add to Home Screen"
            </p>
          ) : (
            <>
              <p className="text-white/70 text-xs mt-1">Add it to your home screen — opens full-screen, no browser bar.</p>
              <Button
                size="sm"
                onClick={install}
                className="mt-2 bg-[#C85A38] hover:bg-[#B85540] text-white rounded-lg text-xs h-7 px-3"
                data-testid="install-app-button"
              >
                Install
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
